import React from 'react';

import { Box, Typography } from '@mui/material';

import { CARD_SX } from '../PriceParrotParityTool/constants';

interface Props {
  label: string;
  value: string;
  caption?: string;
}

export default function StatTile({ label, value, caption }: Props) {
  return (
    <Box sx={{ ...CARD_SX, flex: 1, minWidth: 180, p: 2.5 }}>
      <Typography sx={{ fontSize: 12, color: 'text.secondary', fontWeight: 500, mb: 1 }}>{label}</Typography>
      <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1.1, mb: 0.5 }}>{value}</Typography>
      {caption && <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{caption}</Typography>}
    </Box>
  );
}
